;(function () {
  angular
    .module('contrast.org.vulnerabilities')
    .controller('VulnDiscussionCtrl', VulnDiscussionCtrl)

  function VulnDiscussionCtrl(
    $scope,
    $controller,
    $routeSegment,
    $routeParams,
    logger,
    vulnDiscussionService,
    appTracesApiConfig,
    traceRenderService,
    ErrorService,
    ORG_VULN_EVENTS
  ) {
    'ngInject'

    $scope.model.note = ''

    this.$onInit = function () {
      angular.extend($scope, {
        deleteNote: deleteNote,
        addNote: addNote,
        editNote: editNote
      })

      init()
    }

    function init() {
      var baseCtrl = $controller('BaseVulnDiscussionCtrl', { $scope: $scope })
      baseCtrl.$onInit()

      $scope.onTracesOverviewLoad(load)

      if ($scope.model.trace) {
        load()
      }

      _emitTraceActiveEvent()
    }

    function _emitTraceActiveEvent() {
      var eventName = ORG_VULN_EVENTS.ORG_TRACE_ACTIVE
      if ($routeParams.serverId) {
        eventName = ORG_VULN_EVENTS.SERVER_TRACE_ACTIVE
      } else if ($routeParams.appId) {
        eventName = ORG_VULN_EVENTS.APP_TRACE_ACTIVE
      }
      $scope.$emit(eventName, { active: 'discussion' })
    }

    function load() {
      if (
        $routeSegment.name == 'serverDashboard.vuln.discussion' ||
        $routeSegment.name == 'vulnOverview.discussion' ||
        $routeSegment.name == 'appDashboard.vuln.discussion'
      ) {
        if ($routeParams.uuid === $scope.getTraceUuid()) {
          traceRenderService
            .loadNotes($scope, $scope.model.appId, $scope.getTraceUuid())
            .then(_startRefreshTask)
        } else {
          $scope.destroyRefreshTask()
        }
      }
    }

    function _startRefreshTask() {
      $scope.startRefreshTask(load)
    }

    function deleteNote(note) {
      $scope.destroyRefreshTask()

      vulnDiscussionService.deleteNote().then(function (confirmed) {
        if (confirmed) {
          appTracesApiConfig
            .deleteNote($scope.model.appId, $scope.getTraceUuid(), note.id)
            .then(function (response) {
              logger.logSuccess(response.data.messages[0])
            })
            .then(load)
            .then($scope.emitTraceDiscussionDeleteEvent)
            .catch(ErrorService.processError)
        }
      })
    }

    function addNote() {
      $scope.destroyRefreshTask()
      traceRenderService
        .addNote($scope, $scope.model.appId, $scope.getTraceUuid())
        .then(load)
        .then($scope.emitTraceDiscussionAddEvent)
    }

    function editNote(note, data) {
      traceRenderService
        .editNote($scope.model.appId, $scope.getTraceUuid(), note, data)
        .then(load)
    }
  }
})()
